import React from 'react'
import ReactDOM from 'react-dom/client'
// Body: Roboto Flex (alternativa open-source a Google Sans Flex). Variable
// con multipli assi; usiamo opsz.css per avere wght + opsz (ottimizzazione
// automatica del rendering in base a font-size).
import '@fontsource-variable/roboto-flex/opsz.css'
// Display: Roboto Slab Variable, slab serif coerente con la famiglia Roboto.
import '@fontsource-variable/roboto-slab'
import App from './App.jsx'
import './i18n/i18n.js'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
